import React from 'react';

import { FullWidthContentType } from '../../../models/strapi/full_width_content';

interface Props {
    data: FullWidthContentType;
}

const TextBanner = ({ data }: Props) => {
    return <img src={data.image.image.url} alt={data.image.alt} />;
};

export default TextBanner;
